import * as React from 'react';
import { FaqList } from '../../../components/web/faq/list/faq-list';
import { Container } from '../../../components/web/container/container';

export const Faq: React.FC = () => (
    <section className="pb-[6rem] pt-[2rem] lg:pb-[10rem]">
        <Container>
            <div className="mx-auto max-w-[96rem]">
                <FaqList />
            </div>
        </Container>
    </section>
);
